import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { App } from './App'
import { ApiError } from './api'
import { currentLang, setLang } from './i18n'
import './index.css'

// Dark by default; ?theme=light switches the tokens (no switch in the UI yet).
document.documentElement.dataset.theme = new URLSearchParams(location.search).get('theme') === 'light' ? 'light' : 'dark'
// ?lang=es|ru: the dictionary's language (owner 24.10, E1-UI B4): a switch for checks and screenshots until the
// localization stage; RU stays behind the admin-set flag in the product (AUDIT F-13). Unknown values keep EN.
setLang(new URLSearchParams(location.search).get('lang') ?? 'en')
document.documentElement.lang = currentLang()

// The visual checks' language hook (design rule 24.10: EN / ES / RU where length matters): set only by a
// test's init script. Not a user switch — the cabinet is EN; RU is a per-user flag (owner, 16.10).
const testLang = (window as { __STREVIX_TEST_LANG__?: string }).__STREVIX_TEST_LANG__
if (testLang) setLang(testLang)

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
